import { capitalizeString } from '../../../../utils/jsUtils';
import { getOperatorIcon, getUnits } from '../utils';

const getStockInStoreInfo = (storeDetails, stockCategoryConfig, stockCategoryLimit, textDictionary) => {
  const { id, storeName, stockQuantity } = storeDetails;
  const { number } = stockQuantity;
  const operatorIcon = getOperatorIcon(storeName);
  const classUnits = number <= stockCategoryLimit ? 'not-available' : 'available';
  return {
    storeId: id,
    storeName: capitalizeString(storeName),
    textUnits: getUnits(number, stockCategoryConfig, stockCategoryLimit, textDictionary),
    operatorIcon,
    isValid: true,
    classUnits,
  };
};

export { getStockInStoreInfo };
